
import { Tooltip } from "primereact/tooltip";
import { useEffect, useState } from "react";
import { FaDollarSign, FaEnvelope, FaHandHoldingUsd, FaInbox, FaRegHandshake, FaWallet } from "react-icons/fa";
import AppCard from "../../components/appCard";
import TransfersTable from "../../components/dashboard/transfersTable";
import { useInfo } from "../../context/infoContext";
import { Api } from "../../services/api";
import { formatCurrency } from "../../utils/formatCurrency";

export default function Home() {
  const [feedArray, setFeedArray] = useState([])
  const { dashboardInfo } = useInfo()

  useEffect(() => {
    const carregaFeed = async () => {
      try {
        const { data } = await Api.get('consultas/noticias')
        setFeedArray(data.item)
      } catch (error) {
        if(error && error.response)
        console.log(error.response)
      }
    }
    carregaFeed()
  }, [])

  return (
    <div className="-mt-2 flex flex-wrap w-full">
      <div className="p-2 w-full lg:w-1/6 md:w-1/3">
        <AppCard className="h-full overflow-x-auto">
          <div className="flex justify-between w-full gap-2" >
            <Tooltip target=".rcp" content="Todos os valores recebidos em função da Direto" position='right' />
            <div className="grid">
              <span className="text-sm ">RECUPERADO</span>
              <div className="text-md">{formatCurrency(dashboardInfo.valores?.total_cobrancas_pagas)}</div>
            </div>
            <div className="flex justify-center items-center bg-emerald-300 text-emerald-900 w-fit h-fit rounded-md rcp">
              <FaWallet className="w-[2.5rem] h-[2.5rem] p-3"/>
            </div>
          </div>
        </AppCard>
      </div>
      <div className="p-2 w-full lg:w-1/6 md:w-1/3 sm:w-1/2">
        <AppCard className="h-full overflow-x-auto">
          <div className="flex justify-between w-full gap-2" >
            <Tooltip target=".ngc" content="Valor total negociado na plataforma" position='right' />
            <div className="grid">
              <span className="text-sm ">EM NEGOCIAÇÃO</span>
              <div className="text-md">{formatCurrency(dashboardInfo.valores?.total_cobrancas_pendentes)}</div>
            </div>
            <div className="flex justify-center items-center bg-purple-300 text-purple-900 w-fit h-fit rounded-md ngc">
              <FaRegHandshake className="w-[2.5rem] h-[2.5rem] p-3"/>
            </div>
          </div>
        </AppCard>
      </div>
      <div className="p-2 w-full lg:w-1/6 md:w-1/3 sm:w-1/2">
        <AppCard className="h-full overflow-x-auto">
          <div className="flex justify-between w-full gap-2" >
            <Tooltip target=".abt" content="Valores imputados na plataforma com negociações pendentes" position='right' />
            <div className="grid">
              <span className="text-sm ">A NEGOCIAR</span>
              <div className="text-md">{formatCurrency(dashboardInfo.valores?.total_cobrancas_s_negociacao)}</div>
            </div>
            <div className="flex justify-center items-center bg-cyan-300 text-cyan-900 w-fit h-fit rounded-md abt">
              <FaInbox className="w-[2.5rem] h-[2.5rem] p-3"/>
            </div>
          </div>
        </AppCard>
      </div>
      <div className="p-2 w-full lg:w-3/12 sm:w-1/2">
        <AppCard className="h-full overflow-x-auto">
          <div className="flex justify-between w-full gap-2" >
            <Tooltip target=".prt" content="Valor total de enviados a protesto" position='left' />
            <div className="grid">
              <span className="text-sm ">ENVIADOS A PROTESTO</span>
              <div className="text-md">{formatCurrency(dashboardInfo.valores?.total_protestados)}</div>
            </div>
            <div className="flex justify-center items-center bg-red-300 text-red-900 w-fit h-fit rounded-md prt">
              <FaDollarSign className="w-[2.5rem] h-[2.5rem] p-3"/>
            </div>
          </div>
        </AppCard>
      </div>
      <div className="p-2 w-full lg:w-3/12 sm:w-1/2">
        <AppCard className="h-full overflow-x-auto">
          <div className="flex justify-between w-full " >
            <Tooltip target=".prtr" content="Valor total recuperado com protesto" position='left' />
            <div className="grid">
              <span className="text-sm ">PROTESTADOS (RECUPERADOS)</span>
              <div className="text-md">{formatCurrency(dashboardInfo.valores?.total_protestados_pagos)}</div>
            </div>
            <div className="flex justify-center items-center bg-emerald-300 text-emerald-900 w-fit h-fit rounded-md prtr">
              <FaHandHoldingUsd className="w-[2.5rem] h-[2.5rem] p-3"/>
            </div>
          </div>
        </AppCard>
      </div>
      <div className="p-2 w-full md:w-1/2">
        <AppCard>
          <div className="flex justify-between">
            <div>
              <span className="block text-500 font-medium mb-5">COMUNICAÇÕES</span>
              {dashboardInfo.comunicacoes.total_sms === 0 ? (
                <>
                  <i className="pi pi-spin pi-spinner" style={{ fontSize: "2em" }}></i>
                </>
              ) : (
                <>
                  <div className="text-900 font-medium text-md mt-3">
                    TOTAL DE SMS ENVIADOS: <b>{dashboardInfo.comunicacoes.total_sms ? Number(dashboardInfo.comunicacoes.total_sms).toLocaleString("pt-BR", { useGrouping: true, style: "decimal" }) : 0}</b>
                  </div>
                  <div className="text-900 font-medium text-md mt-3">
                    TOTAL DE EMAILS ENVIADOS: <b>{dashboardInfo.comunicacoes.total_emails ? Number(dashboardInfo.comunicacoes.total_emails).toLocaleString("pt-BR", { useGrouping: true, style: "decimal" }) : 0}</b>
                  </div>
                </>
              )}
            </div>
            <div className="flex items-center justify-center bg-yellow-100 border-round w-10 h-10
              text-yellow-800 rounded-md">
              <FaEnvelope />
            </div>
          </div>
        </AppCard>
        <AppCard className="mt-4">
          <h4 className="text-xl mb-4">Histórico de pagamentos</h4>
          <TransfersTable/>
        </AppCard>
      </div>
      <div className="p-2 w-full md:w-1/2">
        <AppCard>
          <h5 className="text-xl">Notícias</h5>
          {feedArray.length > 0 &&
            <div className="grid mt-2">
              {feedArray.map((value, index) => {
                return (
                  <div className="w-full text-lg" key={index}>
                    <a href={value.link[0]} target="_blank" rel="noopener noreferrer"
                      className='underline'
                    >{value.title[0]}</a>
                  </div>
                )
              })}
              <small className="mt-4 ml-1" >Fonte: br.investing.com</small>
            </div>
          }
        </AppCard>
      </div>
    </div>
  );
}

